import { GraphQLQuery, GraphQLResult } from '@aws-amplify/api';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Field, Form, FormSubmission, ListFieldsQuery, ListFormsQuery, ProcessModule } from 'src/API';
import $log from 'src/log/log';
import { CrudStatus } from './crud-state-slice';

type ProcessModuleBaseState = {
  processModules: {
    list: ProcessModule[];
  };
  forms: Form[];
  fields: Field[];
  formSubmissions: {
    [processModuleID: string]: FormSubmission[];
  };
};

type ProcessModuleState = ProcessModuleBaseState & CrudStatus<ProcessModuleBaseState>;

const initialState: ProcessModuleState = {
  processModules: {
    list: [],
  },
  forms: [],
  fields: [],
  formSubmissions: {},
  _status: {},
};

const reducers = {
  getProcessModules: (state: ProcessModuleState, action: PayloadAction<ProcessModule[]>): void => {
    state.processModules.list = action.payload;
  },

  updateProcessModule: (state: ProcessModuleState, action: PayloadAction<ProcessModule>): void => {
    const index = state.processModules.list.findIndex((d) => d.id === action.payload.id);
    if (index !== -1) {
      state.processModules.list[index] = action.payload;
    }
  },
  getFormsForProcessModule: (
    state: ProcessModuleState,
    action: PayloadAction<GraphQLResult<GraphQLQuery<ListFormsQuery>>>,
  ): void => {
    // console.log('setting forms', action.payload.data?.listForms?.items)
    state.forms = action.payload.data?.listForms?.items as Form[];
  },
  getFields: (state: ProcessModuleState, action: PayloadAction<GraphQLResult<GraphQLQuery<ListFieldsQuery>>>) => {
    state.fields = action.payload.data?.listFields?.items as Field[];
  },
  updateField: (state: ProcessModuleState, action: PayloadAction<Field>): void => {
    const index = state.fields.findIndex((f) => f.id === action.payload.id);
    if (index !== -1) {
      state.fields[index] = action.payload;
    }
  },
  deleteField: (state: ProcessModuleState, action: PayloadAction<string>): void => {
    state.fields = state.fields.filter((f) => f.id !== action.payload);
  },
  updateFormSubmissions: (state: ProcessModuleState, action: PayloadAction<FormSubmission[]>) => {
    // update the proces modules
    const updatedSubmissions = action.payload;
    // update existing form submissions
    updatedSubmissions.forEach((submission) => {
      const processModuleID = submission.processModuleID;
      if (!state.formSubmissions[processModuleID]) {
        state.formSubmissions[processModuleID] = [];
      }
      const index = state.formSubmissions[processModuleID].findIndex((d) => d.id === submission.id);
      if (index !== -1) {
        state.formSubmissions[processModuleID][index] = { ...submission };
      } else {
        state.formSubmissions[processModuleID].push({ ...submission });
      }
    });
  },
};

export const slice = createSlice({
  name: 'processModules',
  initialState,
  reducers: reducers,
});

export const { reducer } = slice;
